export default "__VITE_ASSET__GxaNk7nQ__"